$separator-color: #e2e2e2;
$background-color: white;

.uxn-notification-center {
}

.notification-item {
	padding: 0.5rem;
	background: $background-color;

	header {
		display: grid;
		gap: 6px;
		grid-template-columns: auto 1fr;
		grid-template-rows: auto auto;
		font-size: small;

		#severity {
			grid-column: 1;
			grid-row: 1 / span 2;
			font-size: 48px;
		}

		#sender {
			grid-column: 2;
			grid-row: 1;
			align-self: end;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		#times {
			grid-column: 2;
			grid-row: 2;
			align-self: start;
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: fit-content;
		}

		#sender,
		#creation-date,
		#creation-time,
		#ttl {
			line-height: 1; // override ux defaults
		}

		#creation-date {
			margin-right: 16px;
		}

		ux-icon[name="clock"] {
			margin-left: auto;
		}

		#ttl {
			margin-left: 4px;
		}
	}

	#subject {
		margin: 8px 0 0;
	}

	#message {
		margin: 4px 0 0;
	}
}

.separator {
	text-align: center;
	position: relative;
	margin: 8px 0;
	color: $separator-color;
	background-image: none; // remove ux defaults
}

.separator::after {
	content: attr(aria-label);
	position: absolute;
	transform: translate(-50%, -50%);
	background: $background-color;
	padding: 0 0.5em;
	line-height: 1; // override ux defaults
}

.uxn-notification-center > header {
	position: sticky;
	z-index: 10;
	top: 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;
	background-color: $background-color;

	> p {
		line-height: normal; // override ux defaults
		margin: 0; // override ux defaults
		text-wrap: balance;
		text-align: center;
		flex: 1;
	}

	> a {
		display: flex;
		margin-left: auto;
	}

	ux-icon[name="cog"] {
		font-size: 19px;
	}
}

.uxn-notification-center > header:not(:only-child) {
	padding-bottom: 22px; //TODO find a clean solution!! -> default padding ux-tooltip (30px) - separator margin (8px)
}
